import React, { useEffect, useRef, useState } from 'react';
import { Check, CircleAlert, X } from 'lucide-react';
import './pricing-notice.css';

/** Feedback stays in the viewport even when Save is below a long case list. */
export function PricingNotice({ text, kind, onDismiss, inline = false }: {
  text: string;
  kind: 'ok' | 'err';
  onDismiss: () => void;
  inline?: boolean;
}) {
  const [paused, setPaused] = useState(false);
  const dismiss = useRef(onDismiss);
  dismiss.current = onDismiss;
  useEffect(() => {
    if (kind === 'err' || paused) return undefined;
    const timer = window.setTimeout(() => dismiss.current(), 7000);
    return () => window.clearTimeout(timer);
  }, [kind, text, paused]);

  return <div className={`tma-pricing-notice ${kind}${inline ? ' is-inline' : ''}`}
    onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}
    onFocus={() => setPaused(true)} onBlur={event => {
      if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setPaused(false);
    }}>
    <span className="tma-pricing-notice-icon" aria-hidden="true">{kind === 'ok' ? <Check size={18} /> : <CircleAlert size={18} />}</span>
    <p role={kind === 'err' ? 'alert' : 'status'} aria-atomic="true">{text}</p>
    <button type="button" aria-label="Dismiss notification" onClick={onDismiss}><X size={18} aria-hidden="true" /></button>
  </div>;
}
